import { ReasonsForWithdrawalKeys } from '../../components/WithdrawalForm/WithdrawalForm.types';

export const WithdrawalReasonOptions: Array<{ id: ReasonsForWithdrawalKeys; name: string }> = [
  { id: 'privacyConcerns', name: 'privacyConcerns' },
  { id: 'distanceFromLab', name: 'distanceFromLab' },
  { id: 'insuranceConcerns', name: 'insuranceConcerns' },
  { id: 'unableToProvideSample', name: 'unableToProvideSample' },
  { id: 'piRemovalDueToIneligibility', name: 'piRemovalDueToIneligibility' },
  { id: 'passedAwayPriorToSampleCollection', name: 'passedAwayPriorToSampleCollection' },
  { id: 'removedDueTo3xTnps', name: 'removedDueTo3xTnps' },
  { id: 'other', name: 'other' },
  { id: 'reasonNotSpecified', name: 'reasonNotSpecified' },
];
